import { Box, Checkbox, Skeleton, useMediaQuery } from '@mui/material';
import { styled } from '@mui/system';

import { screenSize } from 'Lib/utilities/screenSize';

export default function FilesCardSkeleton({ hasSelect = false }) {
    const mobile = useMediaQuery(theme => theme.breakpoints.down('mobile'));
    const { smallMobile } = screenSize();

    return Array(15)
        .fill({})
        .map((__, index) =>
            mobile ? (
                <MobileSkeletonCard key={index} smallMobile={smallMobile}>
                    <Skeleton
                        variant="rectangular"
                        sx={theme => ({
                            borderRadius: theme.spacing(smallMobile ? 0 : 3),
                            minWidth: 122,
                            height: '100%'
                        })}
                    />
                    <Box display="flex" flexDirection="column" p={4} gap={3} width="100%" justifyContent="space-between">
                        <Skeleton variant="text" sx={{ fontSize: '16px', width: '8rem' }} />
                        <Box display="flex" gap={4} justifyContent="space-between">
                            <Skeleton variant="text" sx={{ fontSize: '16px', width: '100%' }} />
                            <Skeleton variant="text" sx={{ fontSize: '16px', width: '100%' }} />
                        </Box>
                        <Box display="flex" gap={4} justifyContent="space-between">
                            <Skeleton variant="text" sx={{ fontSize: '16px', width: '4rem' }} />
                            <Skeleton variant="text" sx={{ fontSize: '16px', width: '4rem' }} />
                        </Box>
                        <Box display="flex" justifyContent="space-between">
                            <Skeleton variant="text" sx={{ fontSize: '16px', width: '5rem' }} />
                            {hasSelect && <Checkbox sx={{ p: 0 }} disabled />}
                        </Box>
                    </Box>
                </MobileSkeletonCard>
            ) : (
                <SkeletonCard key={index}>
                    <Skeleton variant="rectangular" height={122} sx={theme => ({ borderRadius: theme.spacing(3, 3, 0, 0) })} />
                    <Box p={4} gap={3} display="flex" flexDirection="column" justifyContent="space-between">
                        <Skeleton variant="text" sx={{ fontSize: '16px', width: '8rem' }} />
                        <Box display="flex" gap={4} justifyContent="space-between">
                            <Skeleton variant="text" sx={{ fontSize: '16px', width: '100%' }} />
                            <Skeleton variant="text" sx={{ fontSize: '16px', width: '100%' }} />
                        </Box>
                        <Box display="flex" gap={4} justifyContent="space-between">
                            <Skeleton variant="text" sx={{ fontSize: '16px', width: '4rem' }} />
                            <Skeleton variant="text" sx={{ fontSize: '16px', width: '4rem' }} />
                        </Box>
                        <Box display="flex" justifyContent="space-between">
                            <Skeleton variant="text" sx={{ fontSize: '16px', width: '5rem' }} />
                            {hasSelect && <Checkbox sx={{ p: 0 }} disabled />}
                        </Box>
                    </Box>
                </SkeletonCard>
            )
        );
}

const SkeletonCard = styled(Box)(({ theme }) => ({
    width: '226px',
    height: '284px',
    boxShadow: 'none',
    borderRadius: theme.spacing(3),
    border: `1px solid ${theme.palette.common.lightgray}`,
    background: theme.palette.common.lightblue
}));

const MobileSkeletonCard = styled(Box, { shouldForwardProp: prop => prop !== 'smallMobile' })(({ theme, smallMobile }) => ({
    width: '100%',
    height: smallMobile ? '233px' : '174px',
    display: 'flex',
    borderRadius: theme.spacing(smallMobile ? 0 : 3),
    border: `1px solid ${theme.palette.common.lightgray}`,
    background: theme.palette.common.lightblue
}));
